import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OrgState {
  currentOrgId: string | null;
  setCurrentOrg: (orgId: string) => void;
  clearCurrentOrg: () => void;
}

export const useOrgStore = create<OrgState>()(
  persist(
    (set) => ({
      currentOrgId: null,
      setCurrentOrg: (orgId: string) => set({ currentOrgId: orgId }),
      clearCurrentOrg: () => set({ currentOrgId: null }),
    }),
    {
      name: "org-storage",
    }
  )
);
